<template>
  <div>
    <el-dialog v-dialogDrag :title=" title" width="1300px" :visible="visible" :close-on-click-modal="false"
      :before-close="() => (visible = false)" append-to-body>
      <el-container :key="key" class="person-selector">
        <el-aside class="aside" width="30%">
          <roleTree v-if="type=='项目公告'" @systemTableClick="clickNodeTree"></roleTree>
          <org-tree v-else ref="orgTree" :role-type="'公告'" @orgcurrent="clickNodeTree">
            <template #default="{ data }">
              <div>
                <img :src="getIcon(data.deptType)" style=" margin-right: 6px" alt="岗位图片" />
              </div>
            </template>
          </org-tree>
        </el-aside>
        <el-main class="main">
          <div class="search">
            <el-input v-model.trim="serchText" size="small" clearable style="margin-bottom: 10px" placeholder="请输入姓名、账号"
              @keyup.enter.native="search" @clear="search"></el-input>
            <el-button type="primary" style="margin-left: 5px" size="small" @click="search">
              搜索
            </el-button>
          </div>
          <el-table ref="tableRef" v-loading="loading" :data="userList" border element-loading-text="数据加载中" height="calc(100% - 100px)"
            highlight-current-row style="width: 100%" @select-all="selectall" @select="selectchange" @row-click="rowClick">
            <el-table-column type="selection" width="55" align="center"></el-table-column>
            <el-table-column type="index" width="60px" label="序号" align="center"></el-table-column>
            <el-table-column prop="name" label="姓名" min-width="130px" show-overflow-tooltip align="center" />
            <el-table-column v-if="type=='项目公告'" prop="userName" label="账号" min-width="100px" align="center" />
            <el-table-column v-else prop="username" label="账号" min-width="100px" align="center" />
          </el-table>
          <page v-if="type=='系统公告'||'文档管理员'" :page="page" :type="1" style="margin-top:20px"
            @handleSizeChange="handleSizeChange" @handleCurrentChange="getPersonList"></page>
        </el-main>
      </el-container>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button type="primary" size="small" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import roleTree from "../structure/roleTree";
import orgTree from "@/CommonDP/components/structure/orgTree.vue";
import prjNoticeService from "@/CommonDP/service/prjNotice-service";
import orgService from "@/CommonDP/service/org-service";
import page from "@/CommonDP/components/paging";
export default {
  components: {
    roleTree,
    orgTree,
    page
  },
  props: {
    isShow: {
      type: Boolean,
      default: false
    },
    selectPersonList: {
      type: Array,
      default: () => []
    },
    type: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      loading: false,
      timer: null,
      serchText: "",
      userList: [],
      currentNode: {},
      currentData: {},
      key: 0,
      searchQuery: { keyword: "", isQueryAll: false },
      page: {
        pageNum: 1,
        pageSize: 20,
        totalCount: 0
      },
      selectPersonTemp: []
    };
  },
  computed: {
    visible: {
      get() {
        return this.isShow;
      },
      set(val) {
        this.$emit("update:isShow", val);
      }
    },
    title() {
      return this.type === '文档管理员' ? '文档管理员' : '选择可见人';
    },
    ...mapState({
      prjInfo: (state) => state.projectMg.prjObj,
      enterpriseId: (state) => state.enterprise.enterpriseId
    })
  },
  watch: {
    serchText(newValue) {
      if (!newValue) {
        if (this.type === "项目公告") this.queryPersonList(this.currentData, this.currentNode);
      }
    },
    isShow(newValue) {
      if (this.isShow) {
        this.selectPersonTemp = JSON.parse(JSON.stringify(this.selectPersonList));
        this.key++;
      }
    }
  },

  methods: {
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getPersonList(1);
    },
    clickNodeTree(data) {
      this.currentNode = data[1];
      this.currentData = data[0];
      if (this.type === "项目公告") {
        this.queryPersonList(data[0], data[1]);
      } else {
        this.getPersonList();
      }
    },
    async queryPersonList(data, node) {
      this.loading = true;
      const { roleId } = data;
      const { prjId } = this.prjInfo;
      const { specId } = this.findFirstNode(node);
      const params = {
        specId,
        roleId,
        prjId,
        enterpriseId: this.enterpriseId
      };
      try {
        if (data.$isOperation === 1) delete params.roleId;
        const result = await prjNoticeService.prjNoticeUserList(params);
        if (result.result === "0") {
          this.userList = result.data;
          const list = [];
          for (let s = 0; s < this.selectPersonTemp.length; s++) {
            for (let g = 0; g < this.userList.length; g++) {
              if (this.selectPersonTemp[s].userId === this.userList[g].userId) {
                list.push(this.userList[g]);
              }
            }
          }
          this.toggleSelection(list);
          this.loading = false;
        }
      } catch (e) {
        this.loading = false;
        this.$message.warning(e.message || "查询人员失败");
      }
    },
    findFirstNode(node) {
      let specId = "";
      let specName = "";
      let stageChildId = "";
      let stageChildName = "";
      const arr = [node];
      while (arr[0]) {
        const lastNode = arr[0];
        const data = lastNode.data || {};
        if (data.specId) {
          specId = data.specId;
        }

        if (data.specName) {
          specName = data.specName;
        }

        if (data.stageChildId) {
          stageChildId = data.stageChildId;
        }

        if (data.stageChildName) {
          stageChildName = data.stageChildName;
        }

        arr.pop();
        if (lastNode.parent) arr.push(lastNode.parent);
      }
      return {
        specId,
        specName,
        stageChildId,
        stageChildName
      };
    },
    search() {
      if (this.type === "项目公告") {
        const { serchText: name } = this;
        if (!name) {
          return this.$message.warning("请输入姓名、账号");
        }
        this.loading = true;
        setTimeout(() => {
          this.userList = this.userList.filter((item) => this.filterKeyword(item, name));
          this.loading = false;
        }, 1000);
      } else {
        this.getPersonList(1);
      }
    },
    filterKeyword(item, name) {
      const keyArr = ["name", "userName"];
      let flag = false;
      while (keyArr[0] && !flag) {
        if (item[keyArr.shift()].includes(name)) flag = true;
      }
      return flag;
    },
    // 部门下的人员列表
    async getPersonList(index = 1) {
      this.loading = true;
      const dep = this.currentData;
      const {
        page: { pageSize },
        searchQuery: { isQueryAll },
        enterpriseId,
        serchText
      } = this;
      const params = {
        deptId: dep.deptId,
        keyword: serchText,
        pageNum: index,
        pageSize,
        enterpriseId,
        isQueryAll: isQueryAll ? 1 : 0
      };
      try {
        const { data, totalCount, pageNum } = await orgService.orgUserList(params);
        this.page.pageNum = pageNum;
        this.page.totalCount = totalCount;
        this.userList = data;
        const list = [];
        for (let s = 0; s < this.selectPersonTemp.length; s++) {
          for (let g = 0; g < this.userList.length; g++) {
            if (this.selectPersonTemp[s].userId === this.userList[g].userId) {
              list.push(this.userList[g]);
            }
          }
        }
        this.toggleSelection(list);
        this.loading = false;
      } catch (e) {
        this.loading = false;
        this.$message.warning(e.message || "查询人员失败");
      }
    },
    submit() {
      this.$emit("change", this.selectPersonTemp);
      this.visible = false;
    },
    selectall(rows) {
      if (rows.length) {
        const result = [];
        if (this.selectPersonTemp.length) {
          for (let i = 0; i < this.userList.length; i++) {
            const obj = this.userList[i];
            const num = obj.userId;
            let isExist = false;
            for (let j = 0; j < this.selectPersonTemp.length; j++) {
              const aj = this.selectPersonTemp[j];
              const n = aj.userId;
              if (n === num) {
                isExist = true;
                break;
              }
            }
            if (!isExist) {
              result.push(obj);
            }
          }
          for (let u = 0; u < result.length; u++) {
            this.selectPersonTemp.push(result[u]);
          }
        } else {
          for (let i = 0; i < this.userList.length; i++) {
            this.selectPersonTemp.push(this.userList[i]);
          }
        }
      } else {
        for (let t = 0; t < this.userList.length; t++) {
          this.removeByValue(this.selectPersonTemp, "userId", this.userList[t].userId);
        }
      }
    },
    selectchange(rows = [], row) {
      const index = this.selectPersonTemp.findIndex(
        (item) => item.userId === row.userId
      );
      if (index < 0) {
        this.selectPersonTemp.push(row);
      } else {
        this.selectPersonTemp.splice(index, 1);
      }
    },
    // 复选框不勾选时需要调用的函数
    removeByValue(arr, attr, value) {
      // 数组，属性，属性值
      let index = 0;
      for (const i in arr) {
        if (arr[i][attr] === value) {
          index = i;
          break;
        }
      }
      arr.splice(index, 1);
    },
    toggleSelection(rows) {
      this.$nextTick(() => {
        if (rows) {
          rows.forEach((row) => {
            this.$refs.tableRef.toggleRowSelection(row);
          });
        } else {
          this.$refs.tableRef.clearSelection();
        }
      });
    },
    getIcon(level) {
      if (level === 1) return require("@/CommonDP/assets/doc/folderParent.png");
      return require("@/CommonDP/assets/doc/folderChild.png");
    },
    rowClick(row) {
      this.$refs.tableRef.toggleRowSelection(row);
      this.$nextTick(() => {
        this.selectchange([], row);
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.person-selector {
  height: 500px;
  .aside {
    margin-right: 20px;
  }
  .main {
    padding: 20px;
    .search {
      display: flex;
      align-items: baseline;
    }
  }
}
</style>
